import { render, staticRenderFns } from "./RiverPassport.vue?vue&type=template&id=708acc84&scoped=true"
import script from "./RiverPassport.vue?vue&type=script&lang=js"
export * from "./RiverPassport.vue?vue&type=script&lang=js"
import style0 from "./RiverPassport.vue?vue&type=style&index=0&id=708acc84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708acc84",
  null
  
)

export default component.exports